import { FC, useContext, useEffect, useState } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import metamask from "../../assets/images/icons/metamask.svg";
import arrow from "../../assets/images/arrow.svg";
import {
  Box,
  Grid,
  Container,
  useMediaQuery,
  MenuItem,
} from "@material-ui/core";

import { useTheme } from "@material-ui/core";
import warningline from "../../assets/images/warningline.svg";
import useStyles from "../Styles/StepperStyles";
import stepperConnectIcon from "../../assets/images/stepperConnectIcon.svg";
import Select from "@material-ui/core/Select";
import { Formik, Form } from "formik";
import WalletContext from "../../store/Wallet/WalletContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import AlertContext from "../../store/Alert/AlertContext";
import { useGraphQLQuery } from "../../utils/grapgql/react-query-graphql.util";
import gql from "graphql-tag";
import { useHistory, useParams, useLocation } from "react-router";
import { validateUserWhitelist } from "../../helpers/validateUser";
import BuyGainModel from "../Modals/BuyGainModel";
import ConfirmationModel from "../Modals/ConfirmationModel";
import { shorter } from "../../utils/web3/formatBalance";
import PoolContext from "../../store/Pool/PoolContext";
import { MdCheckCircle } from "react-icons/md";
import { useAccount } from "wagmi";
import { useWalletConnect } from "../../services/web3/hooks/useWeb3";
import AuthContext from "../../store/Auth/AuthContext";

const HorizontalNonLinearAlternativeLabelStepper: FC<any> = ({
  nochange,
  stepperIndex,
  learnCompleteStep,
  disableModals,
  stepperActiveLearn,
  projectData,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActiveXs = useMediaQuery(theme.breakpoints.down("xs"));

  const { setAlert } = useContext<any>(AlertContext);
  const { userPledges } = useContext<any>(PoolContext);

  const [dataa, setDataa] = useState<any>();
  const { gainsBalance, openmodal } = useContext<any>(WalletContext);
  const { address: account } = useAccount();
  const [open, setOpen] = useState(false);
  
  const { totalTickets } = useContext<any>(SubscriptionContext);
  const { getProfileData } = useContext<any>(AuthContext);
  
  let { ids }: any = useParams();
  const [project, setProject] = useState(ids);
  const LIVEPOOLS_QUERY = gql`
    query pools {
      pools(
        poolSearchQuery: {
          search: ""
          type: "whitelist_open"
          rows: 9999
          listType: "all"
          page: 1
        }
      ) {
        rows {
          id
          name
          description
          image
          contributionStartDate
          contributionEndDate
          totalCap
          totalRaised
          status
          longDescription
        }
        page
        totalPages
        count
      }
    }
  `;

  const { data, error } = useGraphQLQuery<any, any, any>(LIVEPOOLS_QUERY);
  let stepperIndexValue = 0;

  const location = useLocation();

  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState(new Set([-1]));
  const steps = getSteps();
  const [pledgeData, setPledgeData] = useState<any>();
  function getSteps() {
    return ["KYC", "Stake GAINS", "Apply for Whitelist"]
  }
  const { openConnectModal } = useWalletConnect();

  useEffect(() => {
    if (data) {
      setDataa(data);
      projectData &&
        projectData(data.pools?.rows?.filter((row: any) => row.id === project));
    }

    if (error) {
      setAlert(error?.message, "error");
    }
    if (stepperIndex) {
      completed.add(stepperIndexValue);
      setActiveStep(1);
    }
    if (learnCompleteStep) {
      completed.add(stepperIndexValue + 1);
      setActiveStep(2);
    }
  }, [data, error, stepperIndex, project]);

  useEffect(() => {
    if (userPledges) {
      setPledgeData(userPledges);
    }
  }, [userPledges]);

  // const options = {

  //   AF: [<img width="20" src={logo3} className="mr-8" alt="Flow" />, "Flow"],
  //   AF2: [<img width="20" src={logo4} className="mr-8" alt="Near" />, "Near"],
  //   AF3: [<img width="20" src={logo5} className="mr-8" alt="Celo" />, "Celo"],
  // };

  const INITIAL_FORM_STATE = {
    choose: "",
  };

  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const Arrow = () => {
    return <img src={arrow} alt="gains" />;
  };
  // const ArrowDown = () => {
  //   return <img src={arrowdown} alt="gains" />;
  // };

  const Warning = () => {
    return (
      <img src={warningline} className="img-fluid warningimg" alt="warning" />
    );
  };
  const Success = () => {
    return (
      <img
        src={stepperConnectIcon}
        className="img-fluid warningimg"
        alt="success"
      />
    );
  };

  const handleStep = (index: any) => {
    const id = localStorage.getItem("poolId");
    if (index === 1 && totalTickets > 1) {
      history.push(`/learn/${id}`);
    }
    if (index === 0 && location.pathname === `/learn/${id}`) {
      history.push(`/lock-tokens/${id}`);
    }
  };

  function isStepComplete(step: number) {
    return completed.has(step);
  }
  const Icon = () => {
    return <img src={metamask} alt="icon" />;
  };

  const handleChange = (event: any) => {
    setProject(event.target.value);
    history.push(`/lock-tokens/${event.target.value}`);
    localStorage.setItem("poolId", event.target.value);
    setAlert("Project Changed", "success");
  };

  const handleConnectWallet = (event: any) => {
    event.preventDefault();
    if (openConnectModal) openConnectModal();
  };

  const handleCloseWallet = () => {
    
  };

  useEffect(() => {}, [stepperIndex]);

  return (
    <>
      {account && (
        <Box textAlign="center" mt={0.5}>
          <Container fixed>
            <>
              {nochange === true ? null : (
                <Grid container justifyContent="center">
                  <Grid item md={12} xs={12} className="position-relative">
                    <Formik
                      initialValues={{
                        ...INITIAL_FORM_STATE,
                      }}
                      onSubmit={(values) => {
                        console.log(values);
                      }}
                    >
                      <Form className="icondropdown ">
                        <Select
                          value={project}
                          onChange={handleChange}
                          margin="dense"
                          variant="outlined"
                        >
                          {dataa?.pools?.rows?.map((mydata: any) => {
                            if (
                              validateUserWhitelist(mydata.id, pledgeData)
                            ) {
                              return;
                            } else {
                              return (
                                <MenuItem key={mydata.id} value={mydata.id}>
                                  <img
                                    width="20"
                                    height="20"
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                    src={mydata.image}
                                    className="mr-8"
                                    alt={mydata.name}
                                  />{" "}
                                  {mydata.name}
                                </MenuItem>
                              );
                            }
                          })}
                        </Select>
                        <Box className="textlenght" mt={1}>
                          <Typography
                            align={isActive ? "left" : "center"}
                            variant="subtitle1"
                            className="text-darkslate fw-normal"
                          >
                            Change Project
                          </Typography>
                        </Box>
                      </Form>
                    </Formik>
                  </Grid>
                </Grid>
              )}
            </>
          </Container>
        </Box>
      )}
      <Box className={classes.root}>
        <Container fixed>
          <Grid container>
            <Grid item md={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  mr={1}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  className="warningline"
                  position="relative"
                  top={15}
                >
                  <Box>
                    <Button
                      variant="outlined"
                      className="connect-button"
                      color={account ? "primary" : "secondary"}
                      startIcon={account ? <Icon /> : ""}
                      onClick={
                          account
                            ? handleCloseWallet
                            : handleConnectWallet
                      }
                    >
                      {
                        (account)
                          ? <Typography color="primary" variant="caption" style={{
                            justifyContent: 'center',
                          }}>Connected <MdCheckCircle /></Typography>
                          : "Connect Wallet"
                      }
                    </Button>
                  </Box>
                  <Box mt="12px">
                    <Typography variant="subtitle1" className="color fw-normal">
                      {account && shorter(account)}
                    </Typography>
                  </Box>
                </Box>
                {account ? <Success /> : <Warning />}

                <Box>
                  <Stepper
                    alternativeLabel
                    nonLinear
                    activeStep={account && gainsBalance > 0 ? activeStep : -1}
                    connector={<Arrow />}
                  >
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const buttonProps = {};

                      return (
                        <Step
                          key={label}
                          onClick={() => {
                            handleStep(index);
                          }}
                          {...stepProps}
                          className="pointer"
                        >
                          <StepButton
                            className={` ${
                              stepperActiveLearn ? "learnStep" : ""
                            }`}
                            onClick={handleStep}
                            disabled={
                              index > 0
                                ? true
                                : disableModals === false
                                ? true
                                : false
                            }
                            completed={isStepComplete(index)}
                            active={activeStep === index}
                            {...buttonProps}
                          >
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleComplete}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  </Button> */}
                  {openmodal ? (
                    <BuyGainModel open={open} setOpen={setOpen} />
                  ) : (
                    <ConfirmationModel id={ids} open={open} setOpen={setOpen} />
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default HorizontalNonLinearAlternativeLabelStepper;
